import { request } from "../utils/request";

// 获取职位详情页信息
export function getJobInfo(id: string) {
  return request({
    url: "/api/jobs/v1/info",
    method: "GET",
    params: { id },
  });
}
